import { render, staticRenderFns } from "./ErrorAnimationIcon.vue?vue&type=template&id=95eb17aa&scoped=true&"
var script = {}
import style0 from "./ErrorAnimationIcon.vue?vue&type=style&index=0&id=95eb17aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95eb17aa",
  null
  
)

export default component.exports